<template>
  <div class="" style="overflow: auto">
    <b-row class="m-0  pt-5 px-5 justify-content-between">
      <b-img  @click="$router.push('/').catch(err => {})" :src="require(`@/assets/logos/eatDoradoText.png`)" width="250px" style="max-width: 90%; cursor: pointer; z-index: 1000" fluid alt="eatDorado Logo"></b-img>  
    </b-row>


    <b-row class="m-0 justify-content-center">
      <div style="width: 1600px; max-width: 100%">
        <transition name="fade" mode="out-in">
      <b-row class="m-0 pt-3 justify-content-center" :key="1" style="" v-if="!showDetail">
        <b-col md="4">
          <div class="ml-md-5 mt-5 p-3 shadow bg-white rounded">
            
            <b-row class="m-0 justify-content-center">
              <b-img class="mt-3" :src="require(`@/assets/images/undraw_my_current_location.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img>  
              <b-input-group style="width: 90%; " class="mt-3">
                <b-form-input placeholder="z.B. Oelsnitz..."></b-form-input>
                <b-input-group-append>
                  <b-button variant="dark">Suchen</b-button>
                </b-input-group-append>
              </b-input-group>
              

              <b-form-group
                class="mt-4"
                style="width: 90%"
                id="input-group-1"
                label="Entfernung:"
                label-for="input-1"
                :description="distance + ' Km'"
              >
                <b-form-input v-model="distance" min="0" max="25" class="" type="range" placeholder="Enter your name"></b-form-input>
              </b-form-group>

              <b-form-group
                class="mt-4"
                style="width: 90%"
                id="input-group-1"
                label="Bewertung:"
                label-for="input-1"
              >
                  <b-form-rating size="lg" :no-border="true" variant="warning" v-model="rating"></b-form-rating>            
              </b-form-group>
              
            </b-row>

            <p class="text-center mt-4">Entdecke Restaurants in deiner Nähe und somit allerlei Köstlichkeiten</p>
          </div>
        </b-col>
        <b-col cols="12" md="8" style="z-index: 1000 !important">
          <div class="mt-3 mt-md-5 mr-md-5 shadow bg-white rounded p-3">
            <b-row class="m-0 justify-content-center">
              <b-img :src="require(`@/assets/images/undraw_cooking.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img>  
            </b-row>
            <h3 class="text-center mt-4">5 Restaurants in deiner Nähe:</h3>
            <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2">
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
            </div>
          </div>
        </b-col>      
      </b-row>
      <b-row class="m-0 pt-3 justify-content-center" :key="2" style="" v-if="showDetail">
        <b-col cols="12" style="z-index: 1000 !important">
          <div class="mt-3 mt-md-5 shadow bg-white rounded p-3">
            <b-row class="m-0 justify-content-center">
              <b-img :src="require(`@/assets/images/undraw_Hamburger.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img>  
            </b-row>
            <h3 class="text-center mt-4">5 Restaurants in deiner Nähe:</h3>
            <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2">
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
              <restaurant-regular></restaurant-regular>
            </div>
          </div>
        </b-col>      
      </b-row>
    </transition>
      </div>
    </b-row>
    
    <Footer></Footer>
  </div>
</template>

<script>

import coreData from '@/mixins/coreDataMixin'
import RestaurantRegular from '@/views/components/RestaurantRegular'
import Footer from '@/components/Footer'

export default {
  name: 'Login',
  mixins: [coreData],
  components: {
    RestaurantRegular,
    Footer
  },
  data: () => {
    return {
      showDetail: false,
      form: {},
      loginModal: false,
      registerActive: false,
      distance: 13,
      rating: 0
    }
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    }
  },
  mounted(){
    this.$store.commit('updating', false)
  },
  methods: {
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    }
  }
}
</script>

<style lang="scss">

  .triangle-modal {
    position: relative;
    top: -1px;
    height: 7vh;
    clip-path: polygon(0 0,0 100%,100% 0,100% 0);
    -webkit-clip-path: polygon(0 0,100% 0,100% 0,0 100%);
  }

  .showcase-invert {
    transition: all .5s;
    padding: 15px;
    border-radius: 5px;
    border: none;
    //box-shadow: 1px 1px 2px rgba(255,255,255,0.05), 1px 1px 2px rgba(0,0,0, .5) !important
    //box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 1px 1px 5px rgba(0,0,0, .5) !important;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.14);
  }

  .brand-header {
    box-shadow: 5px 5px 5px rgba(255,255,255,0.05), 2px 2px 5px rgba(0,0,0, .5) !important;
    padding: 10px;
    border-radius: 5px;
    background: linear-gradient(60deg,#26c6da,#00acc1);
    &:hover {
        transform: translate(0, -10px);
    }
  }

</style>